import { ApiRequestService } from '../../../shared/services/api-request.service';
import { Injectable } from "@angular/core";
import { MenuItem } from "../../../shared/models/menu-item";
import { CartCalService } from '../../cart/service/cart-cal.service';
import { AppData } from 'src/app/shared';
import { isOfferPresentWithinDate } from 'src/app/shared/utils/common-functions';
import { BehaviorSubject, Subject } from 'rxjs';
import { preCheckoutReqObj } from 'src/app/shared/utils/menu-cart-item-functions';

@Injectable({
  providedIn: "root",
})
export class MenuItemService {
  menuItemModel = new MenuItem();
  isAddonVarientModalOpened = new BehaviorSubject(false);
  searchTextEvent = new Subject();
  searchTextValue
 

  constructor(
    private apiRequestService: ApiRequestService,
    private cartCalService: CartCalService) { 
      this.searchTextEvent.subscribe(data => {
        this.searchTextValue = data
      })
    }

  getMenuItem(outletId, userId) {
    return this.apiRequestService.get('getMenu', '?outletId=' + outletId + '&userId=' + userId);
  }
  async getOutletGroup(obj) {
    console.log('called to check')
    return this.apiRequestService.get("outletGroup", "?restId=" + obj);
  }

  onDisplayQuantity(menuItems) {
    const plateItems = AppData.yourPlateItems;
    let count = 0;
    if (plateItems && plateItems['outlets'].length > 0) {
      const itemsList = plateItems['outlets'][0]['items'];
      if (itemsList !== null && itemsList.length > 0) {
        if (itemsList[0].outletId === menuItems.outletId) {
          itemsList.forEach((item) => {
            if (item.itemId === menuItems.itemId || item.itemId === menuItems.dishId) {
              count += item.quantity;
            }
          });
        }
        return count;
      }
      return count;
    }
    return count;
  }

  getVegCategory(categoryLists, displayMenuList) {
    const catTempList = JSON.parse(JSON.stringify(categoryLists));
    const filteredCategory = JSON.parse(JSON.stringify(this.vegOnlyCatItems(catTempList, displayMenuList)));
    return filteredCategory;
  }

  vegOnlyCatItems(catLists, displayMenuList) {
    let categoryFilterList;
    if (catLists && catLists.length > 0) {
      categoryFilterList = catLists.filter((elem, index) => {
        let subCategories
        if (elem.hasSubCategories) {
          subCategories = elem.subCategories.filter((item, id) => {
            const subMenuItemList = this.filterVegMenu(item.menuItems, displayMenuList)
            if (subMenuItemList && subMenuItemList.length > 0) {
              item.menuItems = subMenuItemList
              return item
            }
          })
          if (subCategories.length > 0) {
            return elem.subCategories = subCategories;
          } else {
          }
        } else if (elem.hasSubCategories !== true) {
          const menuItemsList = this.filterVegMenu(elem.menuItems, displayMenuList)
          if (menuItemsList.length > 0) {
            return elem.menuItems = menuItemsList
          }
        }
      })
    }
    return categoryFilterList
  }

  filterVegMenu(menuList, displayMenuList) {
    let menuItemList = []
    if (menuList) {
      menuList.forEach(menuId => {
        if (displayMenuList[menuId] && displayMenuList[menuId].isVeg && !displayMenuList[menuId].containsEgg) {
          menuItemList.push(menuId)
        }
      })
    }
    return menuItemList;
  }
  searchInfo(menuList, fieldName, searchStr) {
    let filterList = [];
    filterList = menuList.filter((inputObj) => {
      if (inputObj.type === "item") {
        return inputObj[fieldName].toLowerCase().indexOf(searchStr) >= 0;
      }
    });
    return filterList;
  }

  addFavourite(body) {
    return this.apiRequestService.post('addFavourite', body);
  }

  async noSelfPickupOrder() {
    const reqBody = preCheckoutReqObj();
    await this.apiRequestService.post("noSelfPickup", reqBody).then((res) => {
      const responseData = res["body"]["data"]['cartDoc'];
      AppData.yourPlateItemsSub$.next(
        (responseData)
      );
    });
  }
  async selfPickupOrder() {
    const reqBody = preCheckoutReqObj();
    await this.apiRequestService.post("selfPickup", reqBody).then((res) => {
      const responseData = res["body"]["data"]['cartDoc'];
      AppData.yourPlateItemsSub$.next(
        (responseData)
      );
    });
  }

  getOfferPrice(offerList, price) {

    if (offerList) {
      for (var i = 0; i < offerList.length; i++) {
        if (isOfferPresentWithinDate(offerList[i])) {
          return this.cartCalService.calculateDiscount(offerList[i], price);
        }
      }
    }
  }


}

